import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { Text } from "../../../core";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../core";

const EmptyStateGuide = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] space-y-4 p-8">
      <div className="p-4 rounded-full bg-gray-100 dark:bg-dark-400">
        <Plus size={32} className="text-gray-600 dark:text-gray-400" />
      </div>

      <Text variant="h2">{t("assignments.empty.title")}</Text>

      <Text variant="p" status="subtle" size="base" className="text-center">
        {t("assignments.subtitle")}
      </Text>
    </div>
  );
};

export default EmptyStateGuide;
